export const radiusLabel = (metres) => {
  const value = Number(metres);
  return Number.isFinite(value) && value > 0 ? `${value} m (${value / 1000} km)` : "Franchise radius";
};
